"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDragAndDrop = void 0;
const react_1 = require("react");
const sortable_1 = require("@dnd-kit/sortable");
function useDragAndDrop(data, setData, match) {
    const matchRef = (0, react_1.useRef)(match);
    matchRef.current = match;
    const dragChangeRef = (0, react_1.useRef)({ sourceIndex: 0, targetIndex: 0 });
    const [drag, setDrag] = (0, react_1.useState)();
    const onDragStart = (0, react_1.useCallback)((event) => {
        const index = data.findIndex(item => matchRef.current(item, event.active.id));
        // store original source index for use when saving to server
        dragChangeRef.current.sourceIndex = index;
        dragChangeRef.current.targetIndex = index;
        setDrag(data[index]);
    }, [data]);
    const onDragOver = (0, react_1.useCallback)((event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) {
            return;
        }
        // setData(data => {
        // });
        const sourceIndex = data.findIndex(item => {
            return matchRef.current(item, active.id);
        });
        const targetIndex = data.findIndex(item => {
            return matchRef.current(item, over.id);
        });
        // store target index for use when saving
        dragChangeRef.current.targetIndex = targetIndex;
        return (0, sortable_1.arrayMove)(data, sourceIndex, targetIndex);
    }, [data]);
    const onDragEnd = (0, react_1.useCallback)(() => {
        // check original source and target index
        const { sourceIndex, targetIndex } = dragChangeRef.current;
        const didMove = sourceIndex > -1 && targetIndex > -1 && sourceIndex !== targetIndex;
        setDrag(undefined);
        return didMove ? { sourceIndex, targetIndex } : undefined;
    }, []);
    const onDragCancel = (0, react_1.useCallback)(() => setDrag(undefined), []);
    const handlers = { onDragStart, onDragOver, onDragEnd, onDragCancel };
    return { drag, setDrag, handlers };
}
exports.useDragAndDrop = useDragAndDrop;
//# sourceMappingURL=DragAndDrop.hook.js.map